module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_heat.b3845.png";